import { Theme } from "@mui/material/styles";
import { RADIUS } from "../shape";

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: RADIUS.control,
          textTransform: "none" as const,
          fontWeight: 600,
          boxShadow: "none",
        },
        sizeLarge: {
          height: 48,
        },
        containedPrimary: {
          boxShadow: theme.customShadows.goldButton,
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: theme.customShadows.goldButton,
          },
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          "&:hover": {
            backgroundColor: theme.palette.grey[400],
          },
        },
        outlinedInherit: {
          border: `1px solid ${(theme.palette.grey as unknown as Record<string, string>)["500_32"]}`,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
